/**
 * Presentational popover body: single-select radio list of options.
 * Simple options close the popover on select; options with contextualFields stay open until Done/dismiss.
 */
import RmaListFilterRadioOption, {
    IRmaListFilterRadioOption,
    RmaListFilterOptionId,
} from "../radio-option/rma-list-filter-radio-option";
import { RmaListFilterRadioGroupProvider } from "../radio-option/rma-list-filter-radio-group-context";
import { useRmaListFilterPopoverClose } from "../../rma-list-filter-popover-close-context";
import "./rma-list-filter-options-content.scss";

export interface IRmaListFilterOptionsContentProps {
    value: RmaListFilterOptionId | null;
    options: IRmaListFilterRadioOption[];
    onChange: (id: RmaListFilterOptionId) => void;
}

const RADIO_GROUP_NAME = "rma-list-filter-options";

const RmaListFilterOptionsContent: React.FC<IRmaListFilterOptionsContentProps> = ({
    value,
    options,
    onChange,
}) => {
    const onRequestClose = useRmaListFilterPopoverClose();

    const onSelect = (id: RmaListFilterOptionId) => {
        onChange(id);
        const option = options.find((item) => item.id === id);
        // If the option has no contextual fields, close the popover
        if (option && option.contextualFields == null) {
            onRequestClose();
        }
    };

    return (
        <RmaListFilterRadioGroupProvider
            name={RADIO_GROUP_NAME}
            value={value}
            onSelect={onSelect}
        >
            <div className="rma-list-filter-options-content" role="radiogroup">
                {options.map((option) => (
                    <RmaListFilterRadioOption key={option.id} option={option} />
                ))}
            </div>
        </RmaListFilterRadioGroupProvider>
    );
};

export default RmaListFilterOptionsContent;
